import { motion } from 'framer-motion'
import { cn } from '../utils/helpers'

const Button = ({
  children,
  variant = 'primary',
  size = 'md',
  className = '',
  disabled = false,
  onClick,
  type = 'button',
  ...props
}) => {
  const variants = {
    primary: 'btn-primary',
    secondary: 'btn-secondary',
    outline:
      'bg-transparent text-primary-600 border-2 border-primary-500 shadow-sm hover:bg-primary-50 dark:text-primary-300 dark:border-primary-400 dark:hover:bg-primary-900/20',
    ghost:
      'bg-transparent text-primary-600 shadow-none hover:bg-primary-50 dark:text-primary-300 dark:hover:bg-gray-700/50',
  }

  const sizes = {
    sm: 'px-3 py-1.5 text-sm rounded-lg',
    md: 'px-6 py-3 text-base rounded-xl',
    lg: 'px-8 py-4 text-lg rounded-xl',
  }

  const motionProps = variant === 'ghost' || variant === 'outline'
    ? { whileHover: !disabled ? { scale: 1.02 } : {}, whileTap: !disabled ? { scale: 0.98 } : {} }
    : { whileHover: !disabled ? { scale: 1.05 } : {}, whileTap: !disabled ? { scale: 0.95 } : {} }

  return (
    <motion.button
      type={type}
      className={cn(
        'font-semibold transition-all duration-200 inline-flex items-center justify-center',
        variants[variant] || variants.primary,
        sizes[size] || sizes.md,
        disabled && 'opacity-50 cursor-not-allowed pointer-events-none',
        className
      )}
      onClick={onClick}
      disabled={disabled}
      {...motionProps}
      {...props}
    >
      {children}
    </motion.button>
  )
}

export default Button
